import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { DomSanitizer } from '@angular/platform-browser';

import axios from 'src/app/Service/axios';


@Component({

  selector: 'app-payment',

  templateUrl: './payment.component.html',

  styleUrls: ['./payment.component.css']

})

export class PaymentComponent implements OnInit {

  // href_Android: string = 'return://fleetyar';

  href_Android: string = 'fleetyar://payment';

  bAndroid: boolean = false;

  trip_Obj!: any;

  trip_Obj_1: any = {
    "iTaxiLon_Trip": 128,
    "dtSaveFullTime": "2024-11-26T08:27:15.773",
    "iTaxiLon_User": 21,
    "tiMobileGroup": 214,
    "strDate": "1403/09/06",
    "strTime": "12:00",
    "strSCity": "2811",
    "fSLon": 48.660709,
    "fSLat": 31.3394556,
    "strSAddress": "اهواز، میدان شهدا",
    "strDCity": "3510",
    "fDLon": 51.6699245,
    "fDLat": 32.6527892,
    "strDAddress": "تهران, میدان رسالت خیابان نلسون ماندلا",
    "bCameBack": false,
    "fEstimateKm": 515,
    "bHasStop": false,
    "fEstimateStop": 0,
    "iEstimateRent": 24000000,
    "tiPassenger": 1,
    "bForAnother": false,
    "strPassengersName": "",
    "bForeigner": false,
    "strPassportNumber": "",
    "bNeedHelp": false,
    "bPet": false,
    "bSmoking": false,
    "bCargo": false,
    "strCargoDetail": "",
    "tiCommissionPercentage": 0,
    "iAdvancePayment": 2400000,
    "strUnitID": "",
    "bInvoiceRequired": false,
    "strCompany": "",
    "bIncludingInsurance": false,
    "iInsuranceCost": 0,
    "strComment": "",
    "tiTripStatus": 1,
    "strSTripTime": "        ",
    "dtEndFullTime": "2024-11-26T08:27:15.777",
    "iTripTime_Minute": 0,
    "fFinalKm": 0,
    "iFinalStopTime_Minute": 0,
    "iFinalRent": 0,
    "iCommission": 0,
    "tiPassengerPoints": 0,
    "tiDriverPoints": 0,
    "strDriver_CancelReason": "",
    "strPassenger_CancelReason": "",
    "iCancellationPenalty": 0,
    "iSystemUser": 0,
    "strZarinpalAuthority": "A000000000000000000000000000qyl18wgr"
  };

  mdl_Auth: FormGroup = this._fb.group({

    strAuthority: new FormControl(''),

    strStatus: new FormControl(''),

    AppType: new FormControl(''),

    InvoceType: new FormControl(''),

    InvoiceNum: new FormControl(''),

  })

  mdl_Success: FormGroup = this._fb.group({

    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

  })

  constructor(

    private route: ActivatedRoute,

    private _fb: FormBuilder,

    private _utility: OtherService,

    private gurdService: GurdServiceService,

    private notifyService: NotificationService,

    private sanitizer: DomSanitizer,


  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((query: any) => {

      // console.log(query)

      this.mdl_Auth.patchValue({

        strAuthority: query.Authority,

        strStatus: query.Status,

        AppType: query.AppType,

        InvoceType: query.InvoceType,

        InvoiceNum: query.InvoiceNum,


      })

      this.checkOut(query);

    })

    this.route.url.subscribe((segment) => {

      if (segment[1]?.path == 'mobile') {

        this.bAndroid = true;

      }

    })

  }

  checkOut = async (mdl_Query: any) => {

    this._utility.Showspinner();

    const resp_2 = await axios.post(`FleetYar_CheckPayment`, this._utility.stringNumberToNumber(mdl_Query));

    this._utility.nonespinner();

    let res = JSON.parse(resp_2.data);

    this.trip_Obj = res;

  }

  return_SafeUrl(url: string) {

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);

  }

  openApp() {

    window.open(this.href_Android, "_self");
    
  }



}
